import Vue from 'vue'
import Router from 'vue-router'
import {router as lunchRouter} from './lunchRouter'
import {router as listasRouter} from '@/views/Listas/ListasRouter.js'
import {router as EasylunchExhibidoresRouter} from '@/views/Easylunch/Exhibidores/Headers/router.js'
import {router as NutriequivalenciasRouter} from '@/views/Nutriequivalencias/router.js'
import {router as ExpedientesRouter} from '@/views/Expedientes/router.js';
import {router as WebhookRouter} from '@/views/Webhook/router.js';
import {router as RequestcacheRouter} from '@/views/Requestcache/router.js';

// CONTAINERS
const DefaultContainer = () => import('@/containers/DefaultContainer')

// PEDIDOS
const PedidosIndex = () => import('@/views/Pedidos/PedidosIndex')

// SERVICIOS
const ComprasreportesIndex = () => import('@/views/Compras/ComprasreportesIndex')
const ComprareporteDetail = () => import('@/views/Compras/ComprareporteDetail')

// FACTURAS
const FacturasIndex = () => import('@/views/Facturas/FacturasIndex')
const FacturasDetail = () => import('@/views/Facturas/FacturasDetail')
const FacturasCreator = () => import('@/views/Facturas/FacturasCreator')

// NUTRICIÓN
const NutRecetasMainCard = () => import('@/views/Nutricion/RecetasMainCard')
const NutMenusMainCard = () => import('@/views/Nutricion/MenusMainCard')

// INVENTARIOS
const InventariosIndex = () => import('@/views/Inventarios/InventariosIndex')
const InventariosDetail = () => import('@/views/Inventarios/InventariosDetail')
const BuscadorInventarioIndex = () => import('@/views/Inventarios/BuscadorInventarioIndex')

// HELPER PAGES
const Page404 = () => import('@/views/utils/Page404')
const Login = () => import('@/views/auth/Login')

Vue.use(Router)

export default new Router({
	mode: 'hash', // https://router.vuejs.org/api/#mode
	linkActiveClass: 'open active',
	scrollBehavior: () => ({ y: 0 }),
	routes: [
		{
			path: '/',
			redirect: '/catalogos',
			name: 'Inicio',
			component: DefaultContainer,
			// children: [
			// 	{
			// 		path: 'dashboard',
			// 		name: 'Dashboard',
			// 		component: Dashboard
			// 	}
			// ]
		},

		lunchRouter, EasylunchExhibidoresRouter,
		listasRouter, RequestcacheRouter,
		
		// CocinaeasylunchRouter,
		NutriequivalenciasRouter,
		ExpedientesRouter,
		WebhookRouter,

		// NEXT USUARIOS
		{
			path: '/usuarios',
			redirect: '/usuarios/prefilter/todos',
			component: DefaultContainer,
			children: [

				{
					path: '/usuarios/prefilter/admins',
					name: 'Administradores',
					meta: {
						mode: 'Admin'
					},
					component: () => import('@/views/Usuarios/UsuariosIndex')
				},

				{
					path: '/usuarios/prefilter/restaurantes',
					name: 'Restaurantes',
					meta: {
						mode: 'Restaurant'
					},
					component: () => import('@/views/Usuarios/UsuariosIndex')
				},

				{
					path: '/usuarios/prefilter/:prefilter?',
					name: 'Usuarios',
					component: () => import('@/views/Usuarios/UsuariosIndex'),
					meta: {
						mode: 'Normal'
					}
				}
				
			]
		},

		// COCINA
		{
			path: '/cocina',
			name: 'Cocina',
			redirect: '/cocina/pre-costeo',
			component: DefaultContainer,
			children: [
				{
					path: 'pre-costeo',
					name: 'Pre-costeo',
					component: () => import('@/views/Cocina/PreCosteo'),
				},
				{
					path: 'preparacion',
					name: 'Preparación de alimentos',
					component: () => import('@/views/Cocina/Alimentos'),
				},
				{
					path: 'entradas-y-devoluciones',
					name: 'Entradas y devoluciones',
					component: () => import('@/views/Devoluciones/Devoluciones.vue'),
				},
				{
					path: 'reviews',
					name: 'Reseñas de cocina',
					component: () => import('@/views/Review/ReviewQuicktable.vue'),
				}
			]
		},

		// NUTRICIÓN
		{
			path: '/nutricion',
			redirect: '/nutricion/menus/index',
			component: DefaultContainer,
			children: [
				{
					path: 'recetas/index',
					name: 'Recetas',
					component: NutRecetasMainCard
				},
				{
					path: 'menus/index',
					name: 'Menús (Planes)',
					component: NutMenusMainCard
				}
			]
		},

		// CATALOGOS
		{
			path: '/catalogos',
			redirect: '/catalogos/presentaciones',
			component: DefaultContainer,
			children: [
				
				{
					path: 'articulos',
					name: 'Artículos',
					component: () => import('@/views/Catalogos/CatalogosArticulos.vue')
				},
				{
					path: 'ingredientes',
					name: 'Ingredientes',
					component: () => import('@/views/Catalogos/CatalogosIngredientes.vue')
				},
				{
					path: 'presentaciones',
					name: 'Presentaciones',
					component: () => import('@/views/Catalogos/CatalogosPresentaciones.vue')
				},
				{
					path: 'general',
					name: 'Catalogos generales',
					component: () => import('@/views/Catalogos/CatalogosGeneral.vue')
				},
				{
					path: 'nextbanners',
					name: 'Banners in-app',
					component: () => import('@/views/Catalogos/CatalogosBannersInApp.vue')
				},
				{
					path: 'cupones',
					name: 'Cupones',
					component: () => import('@/views/Catalogos/CatalogosCupones.vue')
				}
			]
		},

		// ADMINISTRACION
		{
			path: '/admin',
			redirect: '/admin/reportes',
			name: 'Administración',
			component: DefaultContainer,
			children: [
				{
					path: 'reportes',
					name: 'Reportes',
					component: () => import('@/views/Administracion/AdministracionReportes')
				},
				{
					path: 'monitor-compras-y-ventas',
					name: 'Monitor de compras y ventas',
					component: () => import('@/views/Administracion/AdministracionMonitorComprasVentas')
				}
			]
		},

		// SERVICIOS
		{
			path: '/compras',
			redirect: '/compras/reportes',
			component: DefaultContainer,
			children: [
				{
					path: 'reportes',
					name: 'Reportes de compras',
					component: ComprasreportesIndex
				},
				{
					path: 'detail/:id',
					name: 'Detalle de reporte de compras',
					component: ComprareporteDetail
				}
			]
		},
		
		// PEDIDOS
		{
			path: '/pedidos',
			redirect: '/pedidos/index',
			component: DefaultContainer,
			children: [
				{
					path: 'index',
					name: 'Pedidos',
					component: PedidosIndex
				},
				{
					path: 'armado',
					name: 'Armado',
					component: PedidosIndex
				}
			]
		},

		// FACTURAS
		{
			path: '/facturas',
			redirect: '/facturas/index',
			component: DefaultContainer,
			children: [
				{
					path: 'index',
					name: 'Facturas',
					component: FacturasIndex
				},
				{
					path: 'nueva',
					name: 'Nueva factura',
					component: FacturasCreator
				},
				{
					path: 'detail/:id',
					name: 'Factura',
					component: FacturasDetail
				}
			]
		},

		// INVENTARIOS
		{
			path: '/inventarios',
			redirect: '/inventarios/levantamiento-fisico',
			component: DefaultContainer,
			children: [
				{
					path: 'levantamiento-fisico',
					name: 'Levantamientos físicos de inventarios',
					component: InventariosIndex
				},
				{
					path: 'detail/:id',
					name: 'Levantamiento de inventario',
					component: InventariosDetail
				},
				{
					path: 'buscador/inv-pedidos/:path',
					name: 'Salidas de inventario por presentación',
					component: BuscadorInventarioIndex
				},
				{
					path: 'buscador/inv-facturas/:path',
					name: 'Entradas de inventario por presentación',
					component: BuscadorInventarioIndex
				}
			]
		},

		// PLATFORM CONTEXT (PLAT)
		{
			path: '/plat',
			// redirect: '/promociones/list',
			component: DefaultContainer,
			children: [
				{
					path: 'general-configs',
					name: 'Configuraciones generales',
					component: () => import('@/views/Plat/ConfiguracionesGenerales')
				},
			]
		},

		// PÁGINAS ESTÁTICAS
		{
			path: '/pages',
			redirect: '/pages/404',
			name: 'Pages',
			component: {
				render (c) { return c('router-view') }
			},
			children: [
				{
					path: '404',
					name: 'Page404',
					component: Page404
				}
			]
		},
		{
			path: '/auth',
			redirect: '/auth/login',
			name: 'Auth',
			component: {
				render (c) { return c('router-view') }
			},
			children: [
				{
					path: 'login',
					name: 'Login',
					component: Login
				},
			]
		},
		{
			path: '*',
			redirect: '/pages/404',
			name: 'Bootstrap'
		}
	]
})
